'use strict';

exports.__esModule = true;
exports.default = {
  STANDARD: 'standard',
  BUTTON_COUNT: 'button_count',
  BUTTON: 'button',
  BOX_COUNT: 'box_count'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-facebook/lib/constants/LikeLayout.js
// module id = 748
// module chunks = 0